import { withFormsy } from 'formsy-react';
import React from 'react';

class Select extends React.Component {

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    this.props.setValue(event.currentTarget.value);
  }

  render() {

    // An error message is returned only if the component is invalid
    const errorMessage = this.props.getErrorMessage();
    const showRequired = this.props.showRequired();

    const {
      showErrors = false,
      label = null,
      required = false,
      name,
      link = null,
      options = []      // name and value
    } = this.props;

    const hasError = showErrors && errorMessage;

    return (
      <div className={"pt-form-group"}>
        {label && (
          <label className="pt-label">
            {label + " "}
            {required && (
              <span className="f5 pt-text-muted">(required)</span>
            )}
          </label>
        )}
        <div className={"pt-form-content" + (hasError ? " pt-intent-danger" : "")}>
          <div className={"pt-select " + (hasError ? " pt-intent-danger" : "")}>
            <select id={name}
                    className="pt-input"
                    dir="auto"
                    onChange={this.changeValue}
                    value={this.props.getValue() || ''} >
              {options.map((option, idx) => (
                <option key={idx} value={option.value}>{option.name}</option>
              ))}
            </select>
            {link && (
              <a href={link} className="link" target="_blank"><span className={`pt-icon pt-icon-share`}></span></a>
            )}
          </div>
          <div className="pt-form-helper-text">
            <div className="inline-error">
              {(showErrors && errorMessage) ? (errorMessage) :
                (showErrors && showRequired) ? "Field is required." : ""}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withFormsy(Select);


// WEBPACK FOOTER //
// ./src/components/form/Select.js